import React from 'react';
import Gallery from '../../components/Gallery.js';
import TextBlockOben from '../../components/TextBlockOben';

const images = [
  {
    src: require('../../images/Diz_Schaf_frei.png'),
    title: 'Diz',
    caption: 'Diz aus unterschiedlichen Hölzern und Formen zum Ausziehen von Wolle'
  },
  {
    src: require('../../images/Einzugsh_Schaf.png'),
    title: 'Einzugshaken',
    caption: 'Einzugshaken Schaf in zwei Größen'
  },
  {
    src: require('../../images/NadelmAlpaka.png'),
    title: 'Stricknadelmaß Alpaka',
    caption: 'Stricknadelmaß Alpaka'
  },
  {
    src: require('../../images/Nadelm_Lama.png'),
    title: 'Stricknadelmaß Lama',
    caption: 'Stricknadelmaß Lama'
  },
  {
    src: require('../../images/NadelmSchaf.png'),
    title: 'Stricknadelmaß Schaf',
    caption: 'Stricknadelmaß Schaf'
  },
  {
    src: require('../../images/Schalfibeln_Holz.png'),
    title: 'Schalfibeln',
    caption: 'Schalfibeln'
  },
];


const Accessoires = (props) => {
  console.log(images);
  return (
    <TextBlockOben>
      <h1>Accessoires</h1>
      <p>Diz, Einzugshaken, Stricknadelmaß, Schalfibeln<br /><br />
        In meinem Atelier handgefertigte kleine Helferlein aus Holz: 
        abstrakt oder in Tiermotiven.<br /><br />
      </p>
      <Gallery images={images} />
    </TextBlockOben>
  );
}


export { Accessoires };
